import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux/store";

const category = (state: RootState) => state.category_reducers;
export const Allcategories = createSelector(
  [category],
  (brands) => brands?.category_data,
);
